import React, { useEffect, useState } from 'react'

import MasterSchedule from 'Containers/City/Page/MasterSchedule'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'

import CountryPage from 'Containers/Country/Page'

import { normalizeGraphQLConnection } from 'shared/graphql/utils'

const GlobalPlaning = props => {
  const { country } = props
  const {
    id,
    code,
    citiesSettings: { nodes: citiesList },
  } = country
  const [isLoaded, setIsLoaded] = useState(false)
  const [masterScheduleData, setMasterScheduleData] = useState({
    clients: [],
    locations: [],
    campaigns: [],
    spies: [],
  })

  const getUniqueData = arr => [
    ...new Map(arr.map(value => [value.id, value])).values(),
  ]

  useEffect(() => {
    const mappedCitiesList = citiesList.map(
      ({ clients, locations, campaigns, spies, ...rest }) => ({
        ...rest,
        clients: normalizeGraphQLConnection(clients),
        locations: normalizeGraphQLConnection(locations),
        campaigns: normalizeGraphQLConnection(campaigns),
        spies: normalizeGraphQLConnection(spies),
      }),
    )

    const masterScheduleData = mappedCitiesList.reduce(
      (acc, city) => {
        return {
          clients: getUniqueData([...acc.clients, ...city.clients]),
          locations: getUniqueData([...acc.locations, ...city.locations]),
          campaigns: getUniqueData([...acc.campaigns, ...city.campaigns]),
          spies: getUniqueData([...acc.spies, ...city.spies]),
        }
      },
      { clients: [], locations: [], campaigns: [], spies: [] },
    )
    setMasterScheduleData(masterScheduleData)
    setIsLoaded(true)
  }, [])

  return (
    <CountryPage
      country={country}
      breadcrumbs={[
        {
          label: 'Global Planing',
        },
      ]}
    >
      {isLoaded ? (
        <MasterSchedule
          countryId={id}
          countryName={country.name}
          clients={masterScheduleData.clients}
          campaigns={masterScheduleData.campaigns}
          locations={masterScheduleData.locations}
          spies={masterScheduleData.spies}
          citiesList={citiesList}
          simpleCountryId={id} // Leo did this because the MasterSchedule is a mess
          countryCode={code}
        />
      ) : (
        <LoadingIndicator />
      )}
    </CountryPage>
  )
}

export default GlobalPlaning
